/**
 * @module errors
 * @package @geenius/adapters/convex
 * @description Defines typed binding errors for the Convex adapter helper.
 */

import { AdapterConfigurationError } from "@geenius/adapters";

/** Error code emitted when a Convex DB adapter binding fails shape validation. */
export type ConvexBindingErrorCode = "CONVEX_DB_ADAPTER_MISMATCH";

/** Error thrown when `withConvexDb` receives a non-conforming adapter binding. */
export class ConvexBindingError extends AdapterConfigurationError {
  readonly convexCode: ConvexBindingErrorCode = "CONVEX_DB_ADAPTER_MISMATCH";

  /**
   * Creates a typed Convex adapter binding error.
   *
   * @param message Human-readable validation failure.
   * @param cause Optional original error that triggered the failure.
   */
  constructor(message: string, cause?: unknown) {
    super(message, "INVALID_CONFIG", cause);
    Object.defineProperty(this, "name", {
      value: "ConvexBindingError",
      enumerable: false,
      configurable: true,
    });
    Object.defineProperty(this, "code", {
      value: this.convexCode,
      enumerable: true,
      configurable: true,
    });
    Object.defineProperty(this, "adapterCode", {
      value: this.convexCode,
      enumerable: true,
      configurable: true,
    });
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
